import React from "react";

const UpdateCompanySkeleton: React.FC = () => {
  return (
    <div className="h-screen w-screen">
      <div className="animate-pulse h-screen max-md:w-screen max-w-xl mx-auto md:my-32">
        <div className="flex mt-4 flex-col gap-4 mx-6">
          <p className="bg-gray-300 w-24 h-4 rounded"></p>
          <div className="shadow-sm border border-gray1 rounded-lg p-2 bg-gray-200 w-44 h-40"></div>
          <div className="flex flex-col gap-2">
            <p className="bg-gray-300 w-20 h-4 rounded"></p>
            <div className="bg-gray-200 h-10 rounded-lg p-2"></div>
          </div>
          <div className="bg-gray-300 h-12 rounded-lg w-full"></div>
        </div>
      </div>
    </div>
  );
};

export default UpdateCompanySkeleton;
